import { render, staticRenderFns } from "./BottomHeader.vue?vue&type=template&id=1daa0d7a&scoped=true&"
import script from "./BottomHeader.vue?vue&type=script&lang=js&"
export * from "./BottomHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daa0d7a",
  null
  
)

export default component.exports